import { useMemo } from 'react';
import { format } from 'date-fns';

interface UseDayExpansionProps {
  daysInSelectedMonth: Date[];
}

interface UseDayExpansionReturn {
  expandedDayKeys: string[];
  toggleDayExpansion: (dayKey: string) => void;
}

export const useDayExpansion = ({ daysInSelectedMonth }: UseDayExpansionProps): UseDayExpansionReturn => {
  // Always expand all days - no state management needed
  const expandedDayKeys = useMemo(() => {
    return daysInSelectedMonth.map(dayDate => format(dayDate, 'yyyy-MM-dd'));
  }, [daysInSelectedMonth]);

  // No-op toggle function since we always want expanded state
  const toggleDayExpansion = () => {
    // Do nothing - days are always expanded
  };

  return {
    expandedDayKeys,
    toggleDayExpansion,
  };
};
